import type { CompanionRegionFilter } from './types';

export const regionFilters: readonly CompanionRegionFilter[] = [
  'همه',
  'ایران',
  'خاورمیانه',
  'اروپا',
  'آسیا',
  'آفریقا',
  'آمریکا',
  'اقیانوسیه',
] as const;

export const regionCount = regionFilters.length - 1;

export const globeCityLabels: Record<string, string> = {
  tehran: 'Tehran',
  vienna: 'Vienna',
  amsterdam: 'Amsterdam',
  stockholm: 'Stockholm',
  cologne: 'Cologne',
  hamburg: 'Hamburg',
  berlin: 'Berlin',
  london: 'London',
  izmir: 'Izmir',
  istanbul: 'Istanbul',
  dubai: 'Dubai',
  sharjah: 'Sharjah',
  'abu-dhabi': 'Abu Dhabi',
  riyadh: 'Riyadh',
  'kuwait-city': 'Kuwait City',
  manama: 'Manama',
  doha: 'Doha',
  muscat: 'Muscat',
  baghdad: 'Baghdad',
  karbala: 'Karbala',
  najaf: 'Najaf',
  kabul: 'Kabul',
  'los-angeles': 'Los Angeles',
  miami: 'Miami',
  toronto: 'Toronto',
  sydney: 'Sydney',
};

const publicAsset = (path: string) => `${process.env.PUBLIC_URL || ''}${path}`;

/** NASA-style textures (three-globe examples) — more photoreal than flat day maps. */
const GLOBE_CDN = 'https://cdn.jsdelivr.net/npm/three-globe@2.31.1/example/img';

export const globeTextureUrls = {
  day: `${GLOBE_CDN}/earth-day.jpg`,
  night: `${GLOBE_CDN}/earth-night.jpg`,
  bump: `${GLOBE_CDN}/earth-topology.png`,
  clouds: `${GLOBE_CDN}/earth-clouds.png`,
  background: `${GLOBE_CDN}/night-sky.png`,
};

/** City marker altitude on globe (radius units). */
export const GLOBE_POINT_ALTITUDE = {
  active: 0.045,
  default: 0.022,
} as const;

export function getGlobeCityLabel(cityId: string): string {
  return globeCityLabels[cityId] ?? cityId;
}

export const globeAssets = {
  day: globeTextureUrls.day,
  night: globeTextureUrls.night,
  clouds: globeTextureUrls.clouds,
  bump: globeTextureUrls.bump,
  specular: publicAsset('/assets/globe/earth-specular.jpg'),
  background: globeTextureUrls.background,
};

export const formatFa = (value: number) => value.toLocaleString('fa-IR');

export const heroValueProps = [
  {
    title: 'مسیر واقعی رشد',
    description: 'هر همراه، داستان خودش را از آموزش و تمرین «من حقیقی» روایت می‌کند.',
  },
  {
    title: 'شبکه زنده جهانی',
    description: 'از تهران تا سیدنی — یک جامعه واحد با زبان مشترک تحول.',
  },
  {
    title: 'ویدیو و تجربه زنده',
    description: 'روایت‌های تصویری کوتاه از شهرهایی که مسیر را ادامه داده‌اند.',
  },
] as const;

export const FEATURED_CITY_CARD_COUNT = 8;
